import script from "./ContextDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ContextDetailPage.vue?vue&type=style&index=0&id=0e2e2804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2e2804"]])

export default __exports__